<template>
  <div v-bind:class="{ 'tla-btn--last': isLast, 'tla-btn--flex': makeModelBot }">
    <button v-if="!makeModelBot" class="tla-btn tla-btn--info" @click="nextButtonClick()" :disabled="isButtonDisabled"
      type="button" :name="nextButtonId" :id="nextButtonId">
      {{ dynamicButtonText }}
    </button>
    <button v-if="makeModelBot" class="tla-btn make-model-button make-model-button__positive" @click="nextButtonClick()"
      :disabled="isButtonDisabled" type="button" :name="nextButtonId" :id="nextButtonId">
      <span>Continue</span>
    </button>
    <span v-if="showMessage" v-show="invalid"
      class="tla-form-group__message tla-form-group__message--spaced tla-form-group__message--error">
      Please fill out the questions above.
    </span>
  </div>
</template>

<script lang="ts">
import {
  Vue, Component, Prop, Inject, Watch, Mixins
} from 'vue-property-decorator';
import {
  State, Getter, Action, Mutation, namespace
} from 'vuex-class';
import { Validator, FieldError } from 'vee-validate';
import { tokenService } from '../../services/TokenService';

@Component
export default class NextButtonComponent extends Vue {
  @Inject('$validator') public $validator!: Validator;

  @Prop({ default: 'Next' })
  public buttonText!: string;

  @Prop({ default: false })
  public isLast!: boolean;

  @Prop({ default: 1 })
  public nextStep!: number;

  @Prop({ default: 1 })
  public previousStep!: number;

  @Prop({ default: null })
  public validationScope!: string;

  @Prop({ default: false })
  public makeModelBot!: boolean;

  public showMessage: boolean = false;

  public buttonClicked: boolean = false;

  private nextButtonId: string = '';

  public get dynamicButtonText(): string {
    return tokenService.replaceToken(this.buttonText);
  }

  public get isButtonDisabled(): boolean {
    return this.invalid && !this.showErrorsOnNext;
  }

  public get currentStep(): number {
    return this.$store.getters['enquiryModule/currentStep'];
  }

  public submitNextStep() {
    this.$store.dispatch('enquiryModule/submitNextStep', this.currentStep + this.nextStep);
  }

  public submitPreviousStep() {
    this.$store.dispatch('enquiryModule/submitNextStep', this.currentStep - this.previousStep);
  }

  public get showErrorsOnNext(): boolean {
    return this.$store.getters['initialSettingsModule/showErrorsOnNext'];
  }

  public get stepErrors(): number {
    return this.$validator.errors.items.filter((x) => x.scope === this.validationScope).length;
  }

  public get stepEnhancedValidationErrors(): number {
    return this.$validator.errors.items.filter((x) => x.scope === this.validationScope && (x.field === 'enhanced-telephone')).length;
  }

  public get invalid(): boolean {
    return this.stepErrors > 0;
  }

  @Watch('stepErrors')
  public stepErrorsChanged(newVal: number, oldVal: number) {
    if (this.buttonClicked && oldVal > newVal) {
      this.$validator.validateAll(this.validationScope).then((valid: boolean) => {
        this.showMessage = !valid;
      });
    }
  }

  public async nextButtonClick() {
    if (!this.showErrorsOnNext) {
      this.submitNextStep();
      return;
    }

    this.$store.dispatch('enquiryModule/submitNextStepClicked', this.validationScope).then(() => {
      this.$validator.validateAll(this.validationScope).then((valid: boolean) => {
        if (valid && this.stepEnhancedValidationErrors === 0) {
          this.submitNextStep();
          this.showMessage = false;
        } else {
          this.showMessage = true;
        }

        this.buttonClicked = true;
      });
    });
  }

  public async resetAllValues() {
    this.buttonClicked = false;
    this.showMessage = false;
  }

  public created() {
    this.$events.on('formReset', this.resetAllValues);
    this.nextButtonId = `next-button-step-${this.currentStep}`;
  }
}
</script>
